import api from './api';

export default {
  getAll() { return api.get('/packages'); },
  getById(id: number) { return api.get(`/packages/${id}`); },
  create(data: any) { return api.post('/packages', data); },
  update(id: number, data: any) { return api.put(`/packages/${id}`, data); },
  delete(id: number) { return api.delete(`/packages/${id}`); }
};
